<div class="onboarding-page">
  <div class="page-header text-center">
    <span class="logo logo-white"></span>
  </div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="card shadow-3 rd-3">
          <div class="card-header text-center">

            <!-- <div class="row justify-content-center">
              <app-wizard-navigation [numberOfPages]="1" [currentPage]="1"></app-wizard-navigation>
            </div> -->

            <h3>{{ 'LANDING.recover-pass-page.h3' | translate }}</h3>

          </div>
          <div class="card-body">

            <form [formGroup]="recoverForm" (ngSubmit)="sendRecoverEmail()" *ngIf="recoverForm">

              <app-text-input formControlName="email" [submitAttempted]="submitAttempted" placeholder="{{ 'GENERAL.email' | translate }}" inputType="email" invalidMsg="{{ 'GENERAL.invalidEmail' | translate }}"></app-text-input>

              <app-alert [msg]="errorMsg" type="danger"></app-alert>
              <app-alert [msg]="successMsg" type="success"></app-alert>

              <app-submit-btn [loading]="loading" inputClasses="w100 btn-lg" btnCopy="{{'LANDING.recover-pass-page.submit' | translate}}" [hasError]="errorMsg"></app-submit-btn>

            </form>

            <form [formGroup]="newPassForm" (ngSubmit)="resetPass()" *ngIf="newPassForm">

              <app-text-input formControlName="password1" [submitAttempted]="submitAttempted" placeholder="{{ 'LANDING.recover-pass-page.newPassword' | translate }}" inputType="password"></app-text-input>
              <app-text-input formControlName="password2" [submitAttempted]="submitAttempted" placeholder="{{ 'LANDING.recover-pass-page.confirmPassword' | translate }}" inputType="password"
                invalidMsg="{{ 'LANDING.recover-pass-page.passwordsInvalid' | translate }}"></app-text-input>

              <app-alert [msg]="errorMsg" type="danger"></app-alert>
              <app-alert [msg]="successMsg" type="success"></app-alert>

              <app-submit-btn [loading]="loading" inputClasses="w100 btn-lg" btnCopy="{{'LANDING.recover-pass-page.submit' | translate}}" [hasError]="errorMsg"></app-submit-btn>

            </form>

            <p *ngIf="newPassForm">
              <a rel="canonical" routerLink="/login">{{ 'LANDING.recover-pass-page.login' | translate }}</a>
            </p>

          </div>
        </div>

      </div>

    </div>
  </div>

</div>
